<ng-container *ngIf="requestData">
    <h4 class="header">On Behalf Request</h4>

    <div class="how-it-work">
        <p><strong>How it works?</strong></p>
        <ol>
            <li><strong>Select user type</strong> from the options below.</li>
            <li><strong>Select reason</strong> from the request reason list.</li>
            <li>Change <strong>delivery location</strong> if needed. The default location is your home office.</li>
            <li>Click the <strong>"Next" button</strong> in the bottom right corner.</li>
        </ol>
    </div>

    <employee-info-block blockTitle="Select User Type">
        <employee-grid-line>
            <div class="radio-block">
                <label>
                    <input type="radio" id="employee" name="userType" [checked]="userType === 'employee'" (change)="userTypeChanged('employee')" />
                    <span> </span>Employee
                </label>
                <label>
                    <input type="radio" id="contractor" name="userType" [checked]="userType === 'contractor'" (change)="userTypeChanged('contractor')" />
                    <span> </span>Contractor
                </label>
                <!-- <label>
                    <input type="radio" id="ppmdEmployee" name="userType" [checked]="userType === 'ppmdEmployee'" (change)="userTypeChanged('ppmdEmployee')" />
                    <span> </span>PPMD Employee
                </label>
                <label>
                    <input type="radio" id="ppmdPrehire" name="userType" [checked]="userType === 'ppmdPrehire'" (change)="userTypeChanged('ppmdPrehire')" />
                    <span> </span>PPMD Prehire
                </label> -->
            </div>
        </employee-grid-line>
        <employee-grid-line>
            <employee-grid-cell cellTitle="User">
                <ui-lookup *ngIf="userType === 'employee'" propertyNameToDisplay="fullName" placeholderText="Search by name or email" dataField="userId"
                    [maxQueryLength]="250" [dataSource]="lookupEmployee$" [value]="preselectedUser"
                    (onSelectData)="userChanged($event)">
                    <ng-template let-option="option" let-query="query">
                        <ui-lookup-option [option]="option" [query]="query"></ui-lookup-option>
                    </ng-template>
                </ui-lookup>
                <ui-lookup *ngIf="userType === 'contractor'" propertyNameToDisplay="fullName" placeholderText="Search by name or email" dataField="userId"
                    [maxQueryLength]="250" [dataSource]="lookupContractor$" [value]="preselectedUser"
                    (onSelectData)="userChanged($event)">
                    <ng-template let-option="option" let-query="query">
                        <ui-lookup-option [option]="option" [query]="query"></ui-lookup-option>
                    </ng-template>
                </ui-lookup>
                <!-- <ui-lookup *ngIf="userType === 'ppmdEmployee'" propertyNameToDisplay="fullName" placeholderText="Search by name or email" dataField="userId"
                    [maxQueryLength]="250" [dataSource]="lookupPeople$" [value]="preselectedUser"
                    (onSelectData)="ppmdUserChanged($event)">
                    <ng-template let-option="option" let-query="query">
                        <ui-lookup-option [option]="option" [query]="query"></ui-lookup-option>
                    </ng-template>
                </ui-lookup>
                <ui-lookup *ngIf="userType === 'ppmdPrehire'" propertyNameToDisplay="fullName" placeholderText="Search by name or email" dataField="userId"
                    [maxQueryLength]="250" [dataSource]="lookupPrehire$" [value]="preselectedUser"
                    (onSelectData)="ppmdUserChanged($event)">
                    <ng-template let-option="option" let-query="query">
                        <ui-lookup-option [option]="option" [query]="query"></ui-lookup-option>
                    </ng-template>
                </ui-lookup> -->
            </employee-grid-cell>
        </employee-grid-line>
        <employee-grid-line>
            <employee-grid-cell cellTitle="Email"
                [cellData]="selectedUserEmailAddress"></employee-grid-cell>
            <employee-grid-cell cellTitle="Office location"
                [cellData]="selectedUserDeliveryFacilityName"></employee-grid-cell>
        </employee-grid-line>
    </employee-info-block>

    <ng-container
        *ngTemplateOutlet="requestData.badgeRequestType === badgeRequestTypeEnum.Resubmission ? resubmitPhoto : default"></ng-container>

    <div class="tabs align-items-center">
        <ng-container *ngFor="let tab of tabs; let last = last">

            <div class="tab-break" *ngIf="last"></div>

            <div class="tab" [class.active]="tab.reasonId===requestReasonPayload.reason"
                [class.photo-update-tile]="tab.reasonId===badgeChangeReasonsCategories.PhotoUpdate"
                [class.disabled]="disableTabs"
                (click)="disableTabs ? $event.stopPropagation() : pickRequestReason(tab)">
                <img [src]="tab.icon" alt="{{ tab.name }}">
                <div class="tab__info">
                    <div class="tab__info--caption">{{ tab.name }}</div>
                    <div class="tab__info--count">{{ tab.placeholder }}</div>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="isNoteBlockShown" class="note-block">
        <div class="note-block__icon">
            <i class="icon-info"></i>
        </div>
        <div class="note-block__title">
            <ng-container [ngSwitch]="requestReasonPayload.reason">
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeLost">
                    <span>Please, if you find your lost badge, bring it to One Team.</span>
                </ng-container>
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeStolen">
                    <span>Please, if you find your stolen badge, bring it to One Team.</span>
                </ng-container>
                <ng-container *ngSwitchCase="badgeChangeReasonsCategories.BadgeDamaged">
                    <span>Please, return your damaged badge to One Team.</span>
                </ng-container>
            </ng-container>
        </div>
    </div>
    
    <div class="details-block">
        <div class="delivery-location">
            <b>Delivery location</b>
            <div>
                <span class="delivery-location__title">
                    Deloitte location where badge can be picked up
                </span>

                <ui-searchable-dropdown keyName="siteId" valueName="siteName" dropdownValueName="siteName"
                    placeholderText="Select Location" [dataList]="requestData.sites" [isSiteDropdown]="false"
                    [currentValue]="requestReasonPayload.deliverySiteName" [dataFilterConfig]="locationFilterConfig"
                    [optionsWidth]="320" (onSelect)="locationChanged($event)">
                </ui-searchable-dropdown>
            </div>
        </div>
    </div>

</ng-container>

<ng-template #default>
    <div class="warning-block" *ngIf="selectedUserEmailAddress">
        <i class="icon-exclamation_mark_circled"></i>
        <span *ngIf="canUpload">This application should not be used for request of a temporary badge.</span>
        <span *ngIf="!canUpload">User already have an active request, to add a new one please cancel the previous one.</span>
    </div>

    <div><b>Select reason for request</b></div>
</ng-template>

<ng-template #resubmitPhoto>
    <div class="warning-block resubmit-photo">
        <i class="icon-info"></i>
        <span>Please recheck the request details below, update it if needed and click the "Next"<br>
            button in the right bottom corner to continue.
        </span>
    </div>

    <div><b>Badge request reason</b></div>
</ng-template>

 <div *ngIf="userCountry === 'USI'" class="visitors-requests" [class.cant-badge]="disableVisitorsTabs">
    <hr>
    <div class="visitor-requests">
        <h4 class="header">Visitor's requests</h4>
        <div><b>Select reason for request</b></div>
    </div>
    <div class="tabs align-items-center">

        <ng-container *ngFor="let tab of visitorsTabs; let last = last">

            <div class="tab"
                 *ngIf="tab.roles | byRole : selectedUserRoleId"
                 [class.active]="tab.categoryId===requestReasonPayload.category && !disableVisitorsTabs"
                 (click)="pickRequestReason(tab)">
                <img [src]="tab.icon" alt="{{ tab.name }}">
                <div class="tab__info">
                    <div class="tab__info--caption">{{ tab.name }}</div>
                    <div class="tab__info--count">{{ tab.placeholder }}</div>
                </div>
            </div>
        </ng-container>

    </div>
</div> 

<div class="bottom-holder"></div>